import React from "react";
import { MdLocationOn } from "react-icons/md";
import { FaHouse } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

import { Helmet } from "react-helmet";
import { latestData } from "../common/data";


const imgUrl = process.env.REACT_APP_IMAGEURL

const Latest = () => {
    const navigate = useNavigate();


    return <>
        <Helmet>
            <title>Farmhouses & Plots for Sale in Noida | Investycoons</title>
            <meta
                name="description"
                content="Explore residential & commercial real estate in Noida, Mumbai, Goa & more. Verified listings, top builders, 0% brokerage. Book your site visit today."
            />
        </Helmet>
        <div className="w-full px-4 sm:px-6 lg:px-8 py-10 bg-white">
            <div className="max-w-7xl mx-auto text-justify">
                <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-gray-800 mb-2">
                    <span className="text-green-600">INVESTYCOONS</span> - Welcome to India’s Trusted Real Estate Partner
                </h1>
                <h2 className="text-lg sm:text-lg md:text-lg font-semibold text-center text-gray-600 mb-6">
                    Buy, Sell & Invest in Prime Properties Across India’s Fastest Growing Cities
                </h2>
                <p className="text-base sm:text-lg text-gray-600 mb-2">
                    Are you looking for high-return real estate investments or a dream home in India’s top cities?
                    <span className="font-semibold text-green-700"> Investycoons</span> brings you verified, RERA-approved residential and commercial properties in
                    Noida, Greater Noida, Delhi, Gurugram, Mumbai, Goa, and Indore. With our deep market insights and builder network,
                    we help you make confident and profitable property decisions.
                    Whether you're a seasoned investor, first-time homebuyer, NRI, or a business owner looking for commercial space,
                    we simplify your real estate journey with expert consultation, curated listings, site visits, and legal support.
                </p>
            </div>

            <div className="text-center mt-8 mb-4">
                <h2 className="text-xl sm:text-2xl md:text-3xl uppercase font-bold text-gray-800">Projects Podcast</h2>
                <h3 className="text-lg sm:text-lg font-semibold text-gray-600 mt-2">
                    Turning Real Estate<span className="text-green-600"> Dreams</span>  into <span className="text-green-600">Reality</span>
                </h3>
            </div>

            <div className="max-w-7xl mx-auto">
                <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-8">LATEST LAUNCHES</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {latestData.map((pro, index) => (
                        <div
                            key={pro.id}
                            onClick={() => navigate(`${pro.route}`)}
                            className="relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition-transform duration-300 transform hover:scale-105 cursor-pointer overflow-hidden"
                        >
                            {/* Image */}
                            <div className="relative h-72 sm:h-80">
                                <img
                                    src={pro.img}
                                    alt={pro.name}
                                    className="w-full h-full object-cover"
                                />
                                <span className="absolute top-4 right-4 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-md">
                                    {pro.type}
                                </span>
                            </div>

                            {/* Card Content */}
                            <div className="p-6">
                                <p className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 uppercase">{pro.name}</p>
                                <p className="text-gray-600 text-sm flex items-center gap-1 mb-1">
                                    <FaHouse className="text-green-500" />
                                    {pro.area}
                                </p>
                                <div className="flex flex-wrap items-center justify-between mt-1 gap-2">
                                    <p className="text-gray-600 text-sm flex items-center gap-1">
                                        <MdLocationOn className="text-green-500" size={18} />
                                        {pro.location}
                                    </p>
                                    <span className="bg-green-500 text-white px-2 py-1 text-sm rounded-full shadow-md">
                                        {pro.price ? `Starts from ₹ ${pro.price}` : 'Price Revealing Soon'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </>

}
export default Latest